import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import NestedForm from '@stimulus-components/rails-nested-form'

window.Stimulus = Application.start()
window.Stimulus.register('nested-form', NestedForm)

const context = require.context('./controllers', true, /\.js$/)

window.Stimulus.load(definitionsFromContext(context))

window.Stimulus.debug = (process.env.NODE_ENV === 'development')
